/** @import {GetServerSideProps} from 'next' */

import { callAPI } from '@synqly/sdk/server'

export { notFound, getOrganizationAuth, Actions, badRequest }

const Actions = /** @type {const} */ ({
  SignIn: 'signin',
  SignUp: 'signup',
  Reset: 'reset',
  SingleSignOn: 'sso',
  Callback: 'callback',
})

/**
 * @param {Parameters<GetServerSideProps>[0]} context
 * @param {string} [message]
 */
function notFound(context, message = null) {
  context.res.statusCode = 404
  return {
    props: {
      error: { statusCode: 404, message },
    },
  }
}

/**
 * @param {Parameters<GetServerSideProps>[0]} context
 * @param {string} [message]
 */
function badRequest(context, message = null) {
  context.res.statusCode = 400
  return {
    props: {
      error: { statusCode: 400, message },
    },
  }
}

/** @param {string} organizationId */
async function getOrganizationAuth(organizationId) {
  if (!organizationId) {
    return { organization: null, ssoProviders: null }
  }
  const { MANAGEMENT_TOKEN: token } = process.env

  const { result: organization } = await callAPI(
    `/v1/organizations/${organizationId}`,
    { token },
  )

  const { result: authConfig } = await callAPI(
    `/v1/auth/logon/${organizationId}`,
    { token },
  )

  if (organization) {
    return {
      organization: {
        id: organization.id,
        name: organization.name,
        fullname: organization.fullname,
      },
      ssoProviders:
        authConfig?.sso_providers?.length > 0 &&
        Object.fromEntries(
          authConfig.sso_providers
            .sort(({ fullname: a, fullname: b }) => a.localeCompare(b))
            .map((ssoConfig) => [ssoConfig.id, ssoConfig]),
        ),
    }
  }

  return { error: new Error(`Unknown organization ${organizationId}`) }
}

/**
 * @typedef {object} AuthContext
 * @property {string} action
 * @property {string[]} params
 * @property {{
 *   signIn: string
 *   singleSignOn: string
 *   signUp: string
 *   reset: string
 * }} routes
 */

/**
 * @callback GetServerSideAuthProps
 * @param {Parameters<GetServerSideProps>[0]} context
 * @param {AuthContext} authContext
 * @returns {ReturnType<GetServerSideProps>}
 */
